export default __webpack_public_path__ + "942704c30a3aea5bf2bc3d275b72fd3c.svg";